export const localStorageKeys = {
    GUEST_CART: 'GUEST_CART',
};
